import { render, staticRenderFns } from "./WithTitle.vue?vue&type=template&id=35d4296b&scoped=true&"
import script from "./WithTitle.vue?vue&type=script&lang=js&"
export * from "./WithTitle.vue?vue&type=script&lang=js&"
import style0 from "./WithTitle.vue?vue&type=style&index=0&id=35d4296b&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d4296b",
  null
  
)

export default component.exports